module.exports = __webpack_public_path__ + "static/nextserver-09514406cddda9ceaf5e49745398bbd6.png";